import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import FounderStory from './components/FounderStory';
import Timeline from './components/Timeline';
import QualityCommitment from './components/QualityCommitment';
import AwardsRecognition from './components/AwardsRecognition';
import SustainabilitySection from './components/SustainabilitySection';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      
      <main className="flex-1 pt-16">
        <HeroSection />
        <FounderStory />
        <Timeline />
        <QualityCommitment />
        <AwardsRecognition />
        <SustainabilitySection />
      </main>
      
      <Footer />
    </div>
  );
};

export default About;